import { useGetApiChatBotDataPublicAcccessGet } from "@/API"
import { ChatBot } from "./ChatBot"
import { Center, LoadingOverlay, Paper, Stack, Text } from "@mantine/core"
import { useSearch } from "@tanstack/react-router"

export function ChatBotPublicAccessPage(props: { workspaceId: string, chatBotId: string }) {
    const { accessKey } = useSearch({ from: "/workspace/$workspaceId/chatBotData/$chatBotDataId/publicChat" })
    const chatBotData = useGetApiChatBotDataPublicAcccessGet({ id: props.chatBotId, accessKey: accessKey })

    return <Paper bg="#f4f4f4" h="100%" p="lg">
        <LoadingOverlay visible={chatBotData.isFetching} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
        {chatBotData.data?.data ?
            <Stack h="100%">
                {
                    chatBotData.data?.data.id && chatBotData.data?.data.chatConfig &&
                    <ChatBot workspaceId={props.workspaceId} chatBotDataId={chatBotData.data?.data.id} chatConfig={chatBotData.data?.data.chatConfig} exportName={chatBotData.data?.data.name ?? ""} accessKey={accessKey} />
                }
            </Stack> :
            <Center h="100%">
                <Text c="gray" size="50px">沒有存取權限</Text>
            </Center>
        }
    </Paper>
}